import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import {
    DURATION_CALCULATED,
    DURATION_CONTENT_WITH_TIMES,
    DURATION_CONTENT_WITHOUT_END_TIME,
    DURATION_CONTENT_WITHOUT_START_TIME,
    DURATION_CONTENT_WITHOUT_TIMES,
    DURATION_NO_SPORTRADAR_DATA,
    DURATION_TO_BE_SET_MANUALLY,
} from '@constants/messages';
import {formatMessageWithBold} from '@modules/events/utils/report';
import {getTimeDifferenceInMinutes, getTimeDifferenceInMinutesWithOneDecimal} from '@utils/momentWrapper';
import {getMinutesAndSeconds} from '@utils/helpers';

const MatchDurationInfo = ({matchData = {}}) => {
    const {match} = matchData || {};

    if (match?.id) {
        const matchStatusName = match?.match_status?.name || '-';
        const startedDateTime = match.started_datetime;
        const endedDateTime = match.ended_datetime;

        let messageContent;

        const startDate = startedDateTime ? moment(startedDateTime) : null;
        const endDate = endedDateTime ? moment(endedDateTime) : null;

        if (!startDate && !endDate) {
            messageContent = DURATION_CONTENT_WITHOUT_TIMES;
        } else if (!endDate) {
            messageContent = DURATION_CONTENT_WITHOUT_END_TIME(startDate.format('YYYY-MM-DD'), startDate.format('HH:mm:ss'));
        } else if (!startDate) {
            messageContent = DURATION_CONTENT_WITHOUT_START_TIME(endDate.format('YYYY-MM-DD'), endDate.format('HH:mm:ss'));
        } else {
            const durationInMinutesWithOneDecimal = getTimeDifferenceInMinutesWithOneDecimal(endDate, startDate);
            const timeDifferenceInMinutes = getTimeDifferenceInMinutes(endDate, startDate);
            const minutesAndSeconds = getMinutesAndSeconds(timeDifferenceInMinutes);
            messageContent = DURATION_CONTENT_WITH_TIMES(
                startDate.format('YYYY-MM-DD'),
                startDate.format('HH:mm:ss'),
                endDate.format('YYYY-MM-DD'),
                endDate.format('HH:mm:ss'),
                durationInMinutesWithOneDecimal,
                minutesAndSeconds
            );
        }

        return (
            <div className='--block --paddingLeft-0-2-em'>
                <div className='info-block-item'>Match status: <strong>{matchStatusName}</strong></div>
                <div className='info-block-item'>{formatMessageWithBold(messageContent)}</div>
                <div className='info-block-item'>{startedDateTime && endedDateTime ? DURATION_CALCULATED : DURATION_TO_BE_SET_MANUALLY}</div>
            </div>
        );
    } else {
        return (
            <div className='--block --paddingLeft-0-2-em'>
                <div className='info-block-item'>{DURATION_NO_SPORTRADAR_DATA}</div>
                <div className='info-block-item'>{DURATION_TO_BE_SET_MANUALLY}</div>
            </div>
        );
    }
};

MatchDurationInfo.propTypes = {
    matchData: PropTypes.object,
};

export default MatchDurationInfo;
